
import { Component, Vue } from 'vue-property-decorator';
import { Action, State } from 'vuex-class';
import { getQueryString, writeCookie, readCookie } from '@/tools/tools';
import {
  wxCallback
} from '@/services/http';

@Component({})
export default class extends Vue {
  created() {
    this.wxLoginCallBack();
  }

 @Action('user/setUserInfoList') setUserInfoList!: Function

 @State('user') userinfor: any

 private async wxLoginCallBack() {
   const res: any = await wxCallback({
     code: getQueryString('code'),
     state: getQueryString('state'),
     companyId: 1
   });
   if (res.data.code === 100) {
     writeCookie('accessToken', res.data.data);
     await this.setUserInfoList();
     const anchor = readCookie('anchor');
     if (anchor) {
       const obj:any = {
         accessToken: res.data.data,
         userName: this.userinfor.userinfolist.nickName,
         userId: this.userinfor.userinfolist.id,
         userPhoto: this.userinfor.userinfolist.headImgUrl,
         macCode: '',
         phone: this.userinfor.userinfolist.phone
       };
       if (this.compareVersion(anchor.version, '3.10.600') >= 0) {
         delete obj.accessToken;
         obj.token = res.data.data;
         (this as any).webTransport.getUserLoginData(JSON.stringify(obj));
       } else if (this.compareVersion(anchor.version, '3.6.5') >= 0) {
         delete obj.accessToken;
         obj.token = res.data.data;
         (window as any).QCefClient.invokeMethod('getUserLoginData', JSON.stringify(obj));
       } else {
         (window as any).JsIntrS.getUserLoginData(obj);
       }
     }
     const path: any = this.$route.query.redirect;
     if (path) {
       this.$router.push(path);
     } else {
       this.$router.push('/');
     }
   } else if (res.data.code === 1021) {
     const anchor = readCookie('anchor');
     const obj = {
       wxOpenId: res.data.data.openid,
       unionId: res.data.data.unionid,
       headImage: res.data.data.headimgurl,
       qqUnionId: '',
       nickName: res.data.data.nickname,
       equip: anchor ? anchor.equip : 4,
       model: anchor ? anchor.model : '',
       equipVersion: anchor ? anchor.version : '',
       version: anchor ? anchor.version : '',
       equipMeid: anchor ? anchor.version : ''
     };
     this.$router.push({
       path: '/bindphone',
       query: obj
     });
   } else {
     this.$message.error(res.data.message);
   }
 }

 // 比较版本
 compareVersion(v1: any, v2: any) {
   v1 = v1.split('.');
   v2 = v2.split('.');
   const len = Math.max(v1.length, v2.length);

   // 调整两个版本号位数相同
   while (v1.length < len) {
     v1.push('0');
   }
   while (v2.length < len) {
     v2.push('0');
   }

   // 循环判断每位数的大小
   for (let i = 0; i < len; i++) {
     const num1 = parseInt(v1[i]);
     const num2 = parseInt(v2[i]);

     if (num1 > num2) {
       return 1;
     } if (num1 < num2) {
       return -1;
     }
   }

   return 0;
 }
}
